export default __webpack_public_path__ + "static/media/Gaurav.561f385b.jpg";